export default "__VITE_PUBLIC_ASSET__f32aaa19__"